import { GetTicketAttributesInputProps } from "shared";
import { axiosClient } from "utilz";

import { apiErrorHandler, getMspId } from "utilz/helpers";
export const getTicketAttributes = async ({
  attributeName,
}: GetTicketAttributesInputProps) => {
  try {
    const url = `/configuration/ticket/attributes/${attributeName}`;

    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }

  // console.log(response.data);
};
